/**
 * SaleDashboardPresenter
 * --
 */
import React, { useRef, useState, useEffect } from 'react';
import {
  Content,
  Row,
  Col,
  TabMenu,
  ModalLayout,
  ShopInformationList,
} from 'components';
import { Spin, Input } from 'antd';
import Dashboard from './components/Dashboard';
import StatisticsFilter from './components/StatisticsFilter';
import StatisticsDaily from './components/StatisticsDaily2';
import StatisticsMenu from './components/StatisticsMenu';
import StatisticsPaymentsMethod from './components/StatisticsPaymentsMethod';
import StatisticsOptionPeriod from './components/StatisticsOptionPeriod';
import StatisticsTimezone from './components/StatisticsTimezone';
import StatisticsDaily_Shop from './components/StatisticsDaily_Shop';
import StatisticsMenu_Shop from './components/StatisticsMenu_Shop';
import StatisticsPaymentsMethod_Shop from './components/StatisticsPaymentsMethod_Shop';
import StatisticsRawData from './components/StatisticsRawData';
import StatisticsRawData_MenuOption from './components/StatisticsRawData_MenuOption';
import StatisticMenuCategory from './components/StatisticsMenuCategory';
// import ShopInformationList from 'routes/admin.routes/admin.orders/OrderList/components/ShopInformationList';

/**----------------------------------------
 * [Component] 매출관리 > 대시보드 - 프레젠터
 * ----------------------------------------
 */
const SaleDashboardPresenter = ({
  permission,
  statisticsType,
  data,
  isLoading,
  currentShop,
  setCurrentShop,
  // shopList,
  // searchKeyword,
  // setSearchKeyword,
  startDate,
  endDate,
  dateRange,
  currentRow,
  rawData,
  onSearch,
  onSelect,
  finalDiscount,
  menuCoupon,
  summaryMode,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 분류별 화면 차트
   * --
   */
  const getChartView = () => {
    // 프로퍼티
    const p = {
      data,
      // shopList,
      currentShop,
      startDate,
      endDate,
      onSelect,
      dateRange,
      finalDiscount,
      menuCoupon,
      summaryMode,
    };
    // 뷰
    // console.log('statisticsType: ', statisticsType);

    const commonStatistic = (
      <StatisticsFilter onReset={onSearch} onSearch={onSearch} />
    );
    /* 매장통계 */
    switch (statisticsType) {
      // 일자별 //
      case 'daily':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticsDaily {...p} />,
          detail: <StatisticsRawData headerData={currentRow} data={rawData} />,
        };

      // 메뉴별 //
      case 'menu':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticsMenu {...p} />,
          detail: (
            <StatisticsRawData_MenuOption
              headerData={currentRow}
              data={rawData}
            />
          ),
        };
      // 메뉴별 //
      case 'option':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticsOptionPeriod {...p} />,
          detail: (
            <StatisticsRawData_MenuOption
              headerData={currentRow}
              data={rawData}
            />
          ),
        };
      // Option별 //
      case 'option_period':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticsOptionPeriod {...p} />,
          detail: <StatisticsRawData data={currentRow} />,
        };
      // 결제수단별 //
      case 'payments':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticsPaymentsMethod {...p} />,
          detail: <StatisticsRawData headerData={currentRow} data={rawData} />,
        };
      // 결제수단별 //
      case 'menu_category':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticMenuCategory {...p} />,
          detail: <StatisticsRawData headerData={currentRow} data={rawData} />,
        };
      // 시간대별 //
      case 'timezone':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticsTimezone {...p} />,
          detail: <StatisticsRawData headerData={currentRow} data={rawData} />,
        };
      // 쇼핑몰 //
      case 'daily_shop':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticsDaily_Shop {...p} />,
          detail: <StatisticsRawData headerData={currentRow} data={rawData} />,
        };
      case 'menu_shop':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticsMenu_Shop {...p} />,
          detail: <StatisticsRawData headerData={currentRow} data={rawData} />,
        };
      case 'payments_shop':
        return {
          statistic: !summaryMode && commonStatistic,
          data: <StatisticsPaymentsMethod_Shop {...p} />,
          detail: <StatisticsRawData headerData={currentRow} data={rawData} />,
        };
      default:
        return {
          statistic: !summaryMode && null,
          data: <Dashboard {...p} />,
          detail: <StatisticsRawData headerData={currentRow} data={rawData} />,
        };
    }
  };

  const statisticView = getChartView().statistic;
  const dataView = getChartView().data;
  const detailView = getChartView().detail;

  /* ===== RENDER ===== */
  return (
    <>
      <Spin spinning={isLoading}>
        <Row>
          {/* ===== Left: 업체목록 ===== */}
          {permission === 'ADMIN' && !summaryMode && (
            <Col x={4} style={{ background: '#fff' }}>
              <Content
                className="boxShadow"
                maxWidth={'100%'}
                padding={0}
                style={{
                  height: '100%',
                  borderRadius: 3.5,
                  borderTop: '1px solid #f7f7f7',
                  position: 'sticky',
                  top: 0,
                }}
              >
                <ShopInformationList
                  // toggle
                  onChange={setCurrentShop}
                  type="STORE"
                  query={{ type: 'STORE' }}
                />
              </Content>
              {/* <Content
                className="boxShadow"
                maxWidth={'100%'}
                padding={0}
                style={{
                  height: '100%',
                  padding: 7.5,
                  borderRadius: 3.5,
                  borderTop: '1px solid #f7f7f7',
                  position: 'sticky',
                  top: 0,
                }}
              >
                <div style={{ marginBottom: 7.5 }}>
                  <Input
                    placeholder="업체명을 입력해주세요"
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                  />
                </div>
                <TabMenu
                  activeKey={currentShop}
                  defaultKey={currentShop}
                  onChange={({ key }) => setCurrentShop(key)}
                  items={shopList.filter(
                    (item) =>
                      item.shop_information_name.indexOf(searchKeyword) >= 0
                  )}
                />
              </Content> */}
            </Col>
          )}

          {/* ===== Right: 차트 ===== */}
          <Col x={permission === 'ADMIN' ? 20 : 24}>
            <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
              {/* ===== 필터 ===== */}
              {/* <StatisticsFilter onReset={onSearch} onSearch={onSearch} /> */}
              {statisticView}
              {statisticView && (
                <>
                  <br />
                  <br />
                </>
              )}

              {/* ===== 페이지 ===== */}
              {dataView}
            </Content>
          </Col>
          {/* ===== Right: 차트 ===== */}
        </Row>
      </Spin>

      {/* ===== 상세모달 ===== */}
      <ModalLayout
        type="drawer"
        maxWidth={statisticsType === 'menu' ? 800 : 1180}
        isOpen={currentRow !== null}
        open={currentRow !== null}
        title="주문상세내역"
        closable={true}
        onCancel={() => onSelect(null)}
      >
        <Spin spinning={isLoading}>
          {/* <StatisticsRawData headerData={currentRow} data={rawData} /> */}
          {detailView}
        </Spin>
      </ModalLayout>
    </>
  );
};

/* ===== DF ===== */
SaleDashboardPresenter.defaultProps = {
  isLoading: false,
  userList: {},
  orderList: [],
  todayOrderList: [],
  orderListRaw: [],
  chartData: {
    menuSales: [],
    weeklyData: [],
  },

  onDownloadExel: () => {},
};
export default SaleDashboardPresenter;
